



































































import GatewayConfig from './GatewayConfig.vue'
import ExtranetUi from '@/views/iot-console/components/extranetui/ExtranetUi.vue';
import { ExtranetData, GatewayData,PcData,DeviceData,GatewayNetworkData} from '@/views/iot-console/components/extranetui/Extranet';
import { generateDeviceDataList, generateGatewayData, generatePcData } from '../extranet.util';
import {
  DeviceConfigDto,
  DeviceGatewayConfigDto,
  DeviceLocalConfigDto,
  ExtranetConfigServiceProxy,
  GatewayConfigDataDTO,
  QueryExportDataVO,
  DeviceDataConfigDto,
} from "@/service-proxies/app-v2/iot-extranet.service-proxies";

const ecsp = new ExtranetConfigServiceProxy()

export default {
  name: "DeviceSetting",
  inject:{
    extranet: "extranet"
  },
  components: {GatewayConfig, ExtranetUi},
  data() {
    return {
      expiryTimeType: 'B',
      isHaveRemoteNetworkIp: false,
      visible: false,
      initData: {},
      showSaveModal:false,
      modalContent:"",
      ipClone: false,
      editerLoading: false,
      
    }
  },
  props: {
    device: {},
    extranetSetting: {},
    tabIndex: {},
  },
  watch: {
  },
  mounted(){
    this.refreshConfigData();
  },
  computed:{
    allStyle(){
      if(this.visible){
        return {
          height: '100%'
        }
      }
      return {
          height: 0
        }
    },
    hasGateway(){
      return this.device && this.device.gatewayCode;
    },
    max(){
      return this.extranetSetting?.max || 0;
    },
    editFeature(){
      return this.extranetSetting?.editEnable || false;
    },
    deleteFeature(){
      return this.extranetSetting?.deleteEnable || false;
    },
    hasLinks(){
      if(!this.initData){
        return false;
      }
      if(!this.initData.local){
        return false;
      }
      if(!this.initData.local.interfaces){
        return false;
      }
      if(!this.initData.local.interfaces.length){
        return false;
      }
      if(!this.initData.local.interfaces[0].vlinks){
        return false;
      }
      if(!this.initData.local.interfaces[0].vlinks.length){
        return false;
      }
      const toInterfaceList = this.initData.local.interfaces[0].vlinks.map(c=>c.toInterface).some(c=>c);
      return toInterfaceList?true:false;
    },
    connectingCodeList(){
      if(this.extranet && this.extranet.remoteConnect) {
        return this.extranet.remoteConnect.data.connectingCodeList
      }
      return [];
    },
    isConnecting(){
      return this.connectingCodeList.find(c=>c===this.device.extranetCode)
    },
  },
  methods: {
    showDrawer() {
      this.visible = true;
      this.refreshEditConfigData();
    },
    handleOkModal() {
      this.showSaveModal = false
    },
    onClose() {
      this.visible = false;
      
    },
    getInitData() {
      let deviceId = ""
      if (this.device.id) {
        deviceId = this.device.id
      }
      let gatewayCode = ""
      if (this.device.gatewayCode) {
        gatewayCode = this.device.gatewayCode
      }
      ecsp.getDeviceConfigData(deviceId, gatewayCode).then((res) => {
        this.initData = res
        this.ipClone = this.initData.ipClone
        this.isHaveRemoteNetworkIp = this.initData.remote.interfaces.length > 1
      })
    },
    saveDeviceConfigData() {
      const ui = this.$refs.extranetuiEditer;
      const data:ExtranetData = ui.getExtranetData();
      const saveData = new DeviceConfigDto();
      saveData.deviceId = this.device.id;

      saveData.deviceLocal = new DeviceLocalConfigDto();
      saveData.deviceLocal.virtualIp= data.pc.virtualIp;
      
      saveData.deviceGateway = new DeviceGatewayConfigDto();
      saveData.deviceGateway.virtualIp = data.gateway.virtualIp;
      saveData.deviceGateway.gatewayCode=data.gateway.code;

      saveData.deviceDataList = data.deviceDataList.map(c=>{
        const item: any = new DeviceDataConfigDto();
        item.deviceName=c.name;
        item.ipClone=c.ipClone;
        item.lanIp=c.physicalIp;
        item.virtualIp=c.virtualIp;
        item.linkGatewayIp=c.linkGatewayIp;
        item.physicalName=c.physicalName;
        return item;
      });
      ecsp.saveExtranetConfig(saveData).then((res) => {
        this.refreshConfigData();
        this.visible = false;
        this.$emit('settingClosed');
      });
    },
    refreshConfigData(){
      let deviceId = ""
      if (this.device.id) {
        deviceId = this.device.id
      }
      let gatewayCode = ""
      if (this.device.gatewayCode) {
        gatewayCode = this.device.gatewayCode
        
      }
      ecsp.getExtranetConfig(deviceId, gatewayCode)
        .then(res=>{
          const ui = this.$refs.extranetui;
          const data = new ExtranetData();
          data.pc=generatePcData(res);
          data.gateway=generateGatewayData(res);
          data.deviceDataList=generateDeviceDataList(res);
          ui?.updateExtranetData(data);
        })
    },
    refreshEditConfigData(){
      let deviceId = ""
      if (this.device.id) {
        deviceId = this.device.id
      }
      let gatewayCode = ""
      if (this.device.gatewayCode) {
        gatewayCode = this.device.gatewayCode
        
      }
      this.editerLoading=true;
      ecsp.getExtranetConfig(deviceId, gatewayCode)
        .then((res:DeviceConfigDto)=>{
          const ui = this.$refs.extranetuiEditer;
          const data = new ExtranetData();
          data.pc=generatePcData(res);
          data.gateway=generateGatewayData(res);
          data.deviceDataList=generateDeviceDataList(res);
          ui?.updateExtranetData(data);
        })
        .finally(()=>{
          this.editerLoading = false;
        });
    }
  }
}
